module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_6005.f1ccc675.png";